<template>
  <div>

    <transition>
      <div v-show="showFilterPanelFlag" class="filter-panel">
        <CheckboxGroup v-model="selected" @on-change="checkAllGroupChange">
          <div v-for="(item,index) in filterFiled" :key="index">
            <Checkbox :label="item.title" style="margin: 2px 5px"></Checkbox>
          </div>
        </CheckboxGroup>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "tableColumnFilter",
    props: {
      filterFiled: {
        type: Array,
        default: []
      },
      defaultCheck: {
        type: Array
      }
    },
    data() {
      return {
        showFilterPanelFlag: true,
        //已选中的数据
        selected: [...this.defaultCheck]
      }
    },
    watch:{
       defaultCheck:{
         deep:true,
         handler(val){
            this.$nextTick(()=>{
               this.selected = [...val]
            })
         }
       },

    },
    created(){
       
    },
    methods: {
      checkAllGroupChange() {
        
        this.$emit('filter-field-change', this.selected);
      }
    }
  }
</script>

<style scoped lang="less">
  .filter-panel {
    width: 166px;
    min-height: 120px;
    // height: 500px;
    position: absolute;
    background-color: white;
    z-index: 9999;
    margin-left: -113px;
    // overflow-y: scroll;
    overflow-y: auto;
  }

  .icon_filter {
    display: inline-block;
    width: 14px;
    height: 14px;
    position: relative;
    top: 5px;
    // background: url("filter.png") no-repeat center center;
  }

</style>